import { Button, Input, message, Space } from 'antd'
import { useToken } from 'app/hooks'
import React, { useState } from 'react'
import { Text, View } from 'styles/reactnative'
import API from 'utils/api'

const CurrencyEdit = ({ code, type, value, refresh=()=>{} }: any) => {
	const [edit, setEdit] = useState(false)
	const [text, setText] = useState(value)
	const { data: token } = useToken()
	return (
		<View style={{ width: '100%' }}>
			{!edit ? (
				<Text
					onClickCapture={() => {
						setEdit(!edit)
					}}>
					{value}
				</Text>
			) : (
				<Space.Compact size={'small'}>
					<Input
						value={text}
						onChange={e => {
							setText(e.target.value)
						}}
					/>
					<Button
						onClick={() => {
							if(!text) return message.error('값을 입력해주세요')
							API.put('/admin/currency', token + '', {
								code,
								type,
								value: text,
							})
								.then(res => {
									message.success('수정완료')
									setEdit(false)
									refresh();
								})
								.catch(e => {
									message.error('수정실패')
									setEdit(false)
								})
						}}>
						수정
					</Button>
				</Space.Compact>
			)}
		</View>
	)
}

export default React.memo(CurrencyEdit)
